import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesComponent } from './pages.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { RouterModule, Routes } from '@angular/router';
import { ProductoComponent } from './producto/producto.component';
import { GestionPedidoComponent } from './gestion-pedido/gestion-pedido.component';
import { GestionPedidoDetalleComponent } from './gestion-pedido-detalle/gestion-pedido-detalle.component';
import { CategoriaComponent } from './categoria/categoria.component';
import { CodigoDescuentoComponent } from './codigo-descuento/codigo-descuento.component';
const routes:Routes=[
{path:'dashboard',component:PagesComponent,

children:[
  {path:'inicio',component:DashboardComponent,data:{titulo:'Inicio'}},
  {path:'',component:DashboardComponent,data:{titulo:'Dashboard'}},
  {path:'producto',component:ProductoComponent,data:{titulo:'Producto'}},
  {path:'categoria',component:CategoriaComponent,data:{titulo:'Categoria'}},
  {path:'gestion-pedido',component:GestionPedidoComponent,data:{titulo:'Gestión Pedido'}},
  {path:'gestion-pedido-detalle/:idPedido',component:GestionPedidoDetalleComponent,data:{titulo:'Gestión Pedido'}},
  {path:'codigo-descuento',component:CodigoDescuentoComponent,data:{titulo:'Código descuento'}}
  ]

}
]

@NgModule({
  
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports:[RouterModule]
})
export class PagesRoutingModule { }
